import React from 'react';
import { connect } from 'react-redux';
import clsx from 'clsx';
import { Table } from 'semantic-ui-react';
import { requestUrl } from '@/constants/urls';
import {
  columnMultiSelect,
  columnName,
  columnNameLink,
  columnProject,
  columnDataset,
  columnDatasetLink,
  columnDataOwners,
  columnRequester,
  columnCreatedOn,
  columnStatus,
  columnTools,
  columnCompletedOn,
  columnTransferType,
  columnWorkspaceName,
  columnWorkspaceNameLink,
  columnReviewTools,
  hasColumn,
} from '@/constants/fields';
import SimpleCell from '@/components/table/SimpleCell';
import MessageCell from '@/components/table/MessageCell';
import SelectableRow from '@/components/table/SelectableRow';
import ListCell from '@/components/table/ListCell';
import DatasetCell from '@/datasets/components/DatasetCell';
import { accessControlForTransfer, requestAccessContext, sortedApproversByEmail } from '../helper';
import { showTransferRequest } from '../actions';
import RequestTools from './RequestTools';
import { approvalStatus } from '../constants';
import RequestTransferCell from '../components/RequestTransferCell';
import RequestWorkspaceCell from '../workspaces/components/RequestWorkspaceCell';
import RequestStatusCell from '../components/RequestStatusCell';
import RequestNameLinkCell from '../components/RequestNameLinkCell';
import RequestNameCell from '../components/RequestNameCell';
import ReviewRequestTools from './ReviewRequestTools';
import RequestApproversList from '../datasets/components/RequestApproversList';
import RequestedByCell from '../components/RequestedByCell';

const RequestRow = ({
  allowTransfer,
  category,
  className,
  columns = [
    columnMultiSelect,
    columnNameLink,
    columnProject,
    columnDatasetLink,
    columnDataOwners,
    columnCreatedOn,
    columnCompletedOn,
    columnStatus,
    columnWorkspaceNameLink,
    columnTools,
  ],
  onCheckBoxClick,
  request,
  showTransfer,
  upward,
  theme,
}) => (
  <SelectableRow
    className={clsx('aridhia-request-row', className)}
    error={request.status === approvalStatus.ERROR}
    selected={request.selected}
    label={request.name}
    columns={columns}
    onClick={() => onCheckBoxClick(category, request.code)}
    warning={!request.requester.active}
  >
    {hasColumn(columns, columnName) && (<RequestNameCell request={request} allowTransfer={allowTransfer} />)}
    {hasColumn(columns, columnNameLink) && (<RequestNameLinkCell request={request} allowTransfer={allowTransfer} />)}
    {hasColumn(columns, columnProject) && (<SimpleCell className="td-request-name" content={request.project_name} />)}
    {hasColumn(columns, columnDataset) && (<SimpleCell content={request.datasets[0]?.catalogue?.title} />)}
    {hasColumn(columns, columnDatasetLink) && (<DatasetCell dataset={request.datasets[0]} />)}
    {hasColumn(columns, columnDataOwners)
        && <ListCell items={sortedApproversByEmail(request)} theme={theme} ListComponent={RequestApproversList} />}
    {hasColumn(columns, columnRequester) && (<RequestedByCell user={request.requester} />)}
    {hasColumn(columns, columnTransferType) && (
    <MessageCell messageId={`transfer.type.${request.transfer.transfer_type}`} />
    )}
    {hasColumn(columns, columnWorkspaceName) && (<SimpleCell content={request.workspace_name} />)}
    {hasColumn(columns, columnWorkspaceNameLink) && (<RequestWorkspaceCell request={request} />)}
    {hasColumn(columns, columnCreatedOn) && (<SimpleCell content={request.createdOn} />)}
    {hasColumn(columns, columnCompletedOn) && (
      <RequestTransferCell
        allowTransfer={allowTransfer}
        onClick={() => showTransfer(category, request.code)}
        request={request}
      />
    )}
    {hasColumn(columns, columnStatus) && (<RequestStatusCell allowTransfer={allowTransfer} request={request} />)}
    {hasColumn(columns, columnTools) && (
    <Table.Cell collapsing>
      <RequestTools
        upward={upward}
        category={category}
        request={request}
        url={requestUrl(request, '#')}
      />
    </Table.Cell>
    )}
    {hasColumn(columns, columnReviewTools) && (
    <Table.Cell collapsing>
      <ReviewRequestTools
        upward={upward}
        category={category}
        request={request}
        url={requestUrl(request, '#')}
      />
    </Table.Cell>
    )}
  </SelectableRow>
);

const mapStateToProps = ({
  auth: { role, currentUser },
}, { request }) => {
  const context = requestAccessContext(request, currentUser);
  return ({ allowTransfer: accessControlForTransfer(context, role.permissions).allowTransfer });
};

const mapDispatchToProps = {
  showTransfer: showTransferRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(RequestRow);
